{
  "version": 1,
  "asset_id": "09ac6906-64cb-4f44-8b93-79f79c248ca9",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/09ac6906-64cb-4f44-8b93-79f79c248ca9/loc-frisco-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/09ac6906-64cb-4f44-8b93-79f79c248ca9/loc-frisco-640.webp",
  "original_filename": "loc-frisco-640.webp",
  "size": 18120,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:26:24Z"
}
